module.exports = __webpack_public_path__ + "static/img/nodata.b4f217dc.png";